import styled from 'styled-components';

const StyledFormStep = styled.div`

text-rendering: optimizeLegibility;

.img-map-test {
  height: auto;
  width: 75vw;
  transform: translate3d(0,3em,0);
  margin: auto;
}

h1, h2, h3, h4, h5, h6 {
  font-family: "Merriweather", serif;
  font-weight: 400;
  letter-spacing: 0.5px;
  color: #9c7456;
}

.form-wrap {
  max-width: 400px;
  background-color: #FFF;
  margin: 80px auto;
  padding:0 40px 0 40px;
}
.form-wrap .form-heading {
  background-color: #607D8B;
  color: rgba(255, 255, 255, 0.5);
  /* border-top: 10px solid #455A64; */
  padding: 20px 40px;
  margin: -40px -40px 40px;
}
.form-wrap .form-heading h1, .form-wrap .form-heading h2, .form-wrap .form-heading h3, .form-wrap .form-heading h4, .form-wrap .form-heading h5, .form-wrap .form-heading h6 {
  color: #FFF;
  margin: 0px;
  padding: 0px;
}
.form-wrap .form-heading p {
  font-size: 0.8em;
  margin: 10px 0px 0px;
  padding: 0px;
}

form .input-group {
  position: relative;
  margin-bottom: 30px;
  border: none;
}
form input {
  font-size: 1.2em;
  font-weight: 300;
  color: #212121;
  border: none;
  border-bottom: 1px solid #9c7456;
  width: 100%;
  margin: 0.167em 0 0 -0.167em;
  padding: 5px 0 7px 0 ;
  background: transparent;
}
form input:focus {
  box-shadow: none;
  outline: none;
}
form input:focus + label:after {
  width: 100%;
  transition: all 0.4s ease-out;
}
form input:focus + label .float-label {
  position: relative;
  top: -0.67em;
  font-size: 0.9em;
  color: #9c7456;
}
form input.active + label .float-label {
  position: relative;
  top: -2em;
  font-size: 0.7em;
  color: #9c7456;
}

#float-label-membership {
  margin: 0 0 0 -0.32em;
}
.formstep-section-back-container {
  display: flex;
  text-align: center;
  margin: auto;
  justify-content: center;
  align-items: center;
  padding: 0;
  max-height: 30px;
  margin-top: 1em;
}
.formstep-section-back-container button{
  background: #e0e0e0;
  display: flex;
  /* font-weight: bold;  */
  border: none;
  border-radius: 1em;
  margin: 0 0 0 -3.97em;
  cursor: pointer;
  font-size: 1em;
  padding: 3px 7px 3px 7px; 
  transform: translate3d(-0.95em,0.02em,0);
  /* top: 13.67vh;
  left: 1em;
  padding: 5px 7px;
  position: absolute; */
}

.formstep-section-back-container-alt button{
  background: #e0e0e0;
  display: flex;
  /* font-weight: bold;  */
  border: none;
  border-radius: 1em;
  /* margin: 0 0 0 -3.97em; */
  cursor: pointer;
  font-size: 1em;
  /* padding: 3px 7px 3px 7px; */
  /* transform: translate3d(-0.95em,0.02em,0); */
  top: 13.67vh;
  left: 1em;
  padding: 5px 7px;
  position: absolute;

}

.formstep-section-back-container button:hover {
  border: 2px solid #9c7456;
}


.formstep-section-title > h3 {
  font-size: 1.88em;
  font-family: 'Bebas Neue', cursive;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  text-align: center;
  transform: scaleY(0.92) translate3d(0,-0.17em,0);
  padding: 0 0 0 0;
  margin-top: 0.1em;
}
.formstep-section-title .formstep-section-back-container > p {
  font-size: 0.75em;
  letter-spacing: 0.01em;
  text-align: center;
  padding: 0;
  position: relative;
  /* top: 2em; */

}
/* form input[type=text]:valid + label:before, form input[type=email]:valid + label:before, form input[type=password]:valid + label:before {
  content: "";
  position: absolute;
  top: 7px;
  right: 8px;
  bottom: 7px;
  width: 23px;
  background-color: #7BD581;
  border-radius: 50%;
  background-image: url("http://jfalotico.com/assets/img/check.png");
  background-size: 17px;
  background-position: center center;
} */
form input[type=text]:invalid:not(:focus).visited + label:before, form input[type=email]:invalid:not(:focus).visited + label:before, form input[type=tel]:invalid:not(:focus).visited + label:before {
  content: "";
  position: absolute;
  top: 7px;
  right: 8px;
  bottom: 7px;
  width: 23px;
  background-color: #C33C54;
  border-radius: 50%;
  background-image: url("http://jfalotico.com/assets/img/close.png");
  background-size: 17px;
  background-position: center center;
  color: #9c7456;
}
form label {
  font-size: 1.1em;
  font-weight: normal;
  filter: drop-shadow(1px 2px 2px  rgba(0,0,0,0.08));
  /* transform: scaleY(1.32); */
  letter-spacing: 0.05;
  position: absolute;
  top: -0.88em;
  right: 0;
  bottom: 0;
  left: -0.67em;
  padding-left: 8px;
  color: #222;
}
form label:after {
  content: "";
  position: absolute;
  bottom: -1px;
  left: 0%;
  height: 3px;
  width: 0%;
  background-color: #9c7456;
  transition: all 0.4s;
}
form label .float-label {
  position: relative;
  top: 0px;
  transition: all 0.3s ease-out;
}

.btn-footer {
  text-align: center;
  /* border-top: 1px solid #B6B6B6; */
  /* background-color: #CFD8DC; */
  margin:  3em 0;
  padding: 2em 0 0 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 1.32em;
}
.btn-footer .back-link {
  font-size: 1.12em;
  width: 14ch;
  max-width: 15ch;
  padding: 5px 7px;
  margin: auto;
  border: none;
  background: transparent;
}
.btn-footer .back-link:hover {
  color: #8C683C;
}

.btn {
  border: none;
  border-radius: 2px;
  padding: 10px 14px;
  min-width: 14ch;
  font-size: 16px;
  text-transform: uppercase;
  background-color: #FFF;
  color: #727272;
  cursor: pointer;
  font-weight: bold;
  transform: scale(1);
  transition: all 0.1s;
  box-shadow: 0 1.5px 4px rgba(0, 0, 0, 0.24), 0 1.5px 6px rgba(0, 0, 0, 0.12);
  border-radius: 16px
}
.btn:hover {
  box-shadow: 0 3px 12px rgba(0, 0, 0, 0.23), 0 3px 12px rgba(0, 0, 0, 0.16);
  transform: scale(1.02);
  transition: all 0.1s;
}
.btn:active, .btn:focus {
  box-shadow: 0 1.5px 4px rgba(0, 0, 0, 0.24), 0 1.5px 6px rgba(0, 0, 0, 0.12);
  outline: none;
  transform: scale(1);
  transition: all 0.1s;
}
/* .btn + .btn {
  margin-left: 15px;
} */
button {
  cursor: pointer;
}
#next-button{
  background-color: #9c7456;
  color: #FFF;
  min-width: 50vw;
  max-width: 60vw;
  align-items: center;
  justify-content: center;
  margin: auto;
}
.btn-primary {
  background-color: #9c7456;
  color: #fff; 
}


/* @media screen and (min-width: 500px){
  .btn-primary {
    position: relative;
    left: 50%;
    transform: translate3d(-50%,0,0);
  }
  .btn:hover {
    box-shadow: 0 3px 12px rgba(0, 0, 0, 0.23), 0 3px 12px rgba(0, 0, 0, 0.16);
    transform: scale(1) translate3d(-50%,0,0);;
    transition: all 0.1s;
  }
  .btn:active, .btn:focus {
    box-shadow: 0 1.5px 4px rgba(0, 0, 0, 0.24), 0 1.5px 6px rgba(0, 0, 0, 0.12);
    outline: none;
    transform: scale(1);
    transition: all 0.1s;
  }
  
} */


/* map location picker */
.map-card {
  box-sizing: border-box;
  background: rgba(235,235,235,0.15);
  box-shadow: 2px 4px 4px rgba(0, 0, 0, 0.15);
  border-radius: 8px;
  padding: 0 1em 2em 1em;
  width: 92vw;
  margin: auto;
  position: relative;
  left: 50%;
  transform: translate3d(-50%,0,0);
}

.map-selections-holder {
position: relative;
left: 50%;
transform: translate3d(-50%,0,0);
margin: 20px auto;
width: 90vw;
height: auto;
min-height: 40vh;
display: flex;
flex-direction: column;
text-align: center;
overflow: hidden;
}
.card-selections {
/* padding: 0.32ch 0 0 0; */
min-height: 20em;
margin: -3em 0 0 0;
display: flex;
flex-wrap: nowrap;
overflow: scroll;
/* background: red; */
width: 100%;
gap: 0.1em;
}
/* ### card-selections for desktop
 flex-direction: column;
max-width: 40vw;
padding: 0;
margin: 1.32em 0 0 0;
overflow: hidden;
height: auto;
overflow-y: scroll; */

.card-item-active{
  background: black !important;
  color: #FFF !important;
  /* border: 2px solid rgba(225, 193, 110,0.5); */
  
}

.card-item {
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  padding: 0 1em 0 1em;
  background: #F4EEE6;
  color: black;
  width: 100%;
  max-width: 33.32ch;
  min-height: 8em;
  border: 2px solid rgba(0,0,0,0.015);
  aspect-ratio: 8 / 1;
}
#item-title {
  font-size: 1.2em;
  color: black;
  font-family: 'Bebas Neue', cursive;
  
}

.card-item-titles {
display: grid;
grid-template-columns: 2fr 1.5fr 1fr;
max-width: 8em;
}

.card-item-titles> h3 {
font-size: 1.32em;
min-width: 35ch;
text-align: left;
padding: 0 0.5em 0 0;
}

.card-item-titles> h3:nth-child(1) {
color: #9c7456 !important;

}
.card-item-address {
 max-width: 12ch;
 text-align: left;
}
.card-item-miles {
  color: #fff;
}

.map-inner {
  height: 300px;
  width: 99%;
  background: #ccc;
  margin: auto;
  background-image: url("https://dl3.pushbulletusercontent.com/NUWJWcMlK7OVuOPX4ufuGl3LT2ZGJ682/image.png");
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
}


.uppercase-first:first-letter {
      text-transform: uppercase;
  }
}







.select-group {
  display: block;
  padding: 0;
  position: relative;
  /* Show only the native arrow */
  color: #8C683C;
  display: block;
  border-radius: 0;
  box-shadow: none;
  font-size: 16px;
  margin-top: -1em;
  margin-bottom: 2em;
  width: 100%;
}
.select-group::before, .select-group::after {
  content: "";
  display: block;
  position: absolute;
  pointer-events: none;
  z-index: 2;
}
.select-group select {
  -webkit-appearance: none;
  -moz-appearance: none;
       appearance: none;
  background: none;
  box-sizing: border-box;
  width: 100%;
  margin: 0;
  border: 1px solid transparent;
  font-size: 1.1em;
  outline: none;
  /* Focus style */
}
.select-group select:focus {
  background-color: transparent;
  outline: none;
}
.select-group option {
  font-weight: normal;
}
.select-group x:-o-prefocus, .select-group::after {
  display: none;
}
@media screen and (-ms-high-contrast: active), (-ms-high-contrast: none) {
  .select-group select::-ms-expand {
    display: none;
  }
  .select-group select:focus::-ms-value {
    background: transparent;
    color: #000;
  }
}
@-moz-document url-prefix() {
  .select-group {
    overflow: hidden;
  }
  .select-group select {
    width: 120%;
    width: calc(100% + 3em);
    /* Firefox focus has odd artifacts around the text, this kills that. See https://developer.mozilla.org/en-US/docs/Web/CSS/:-moz-focusring */
  }
  @supports (-moz-appearance: none) {
    .select-group select {
      width: 100%;
    }
  }
  .select-group select:-moz-focusring {
    color: transparent;
    text-shadow: 0 0 0 #000;
  }
}
@supports (-moz-appearance: none) {
  .select-group {
    width: 100%;
  }
}
.select-group::before, .select-group::after {
  content: "";
  display: block;
  position: absolute;
  pointer-events: none;
  border: 1px solid transparent;
  width: 0;
  height: 0;
  right: 16px;
}
.select-group::before {
  bottom: 65%;
  /* border-width: 0 6.5px 8px 6.5px; */
  border-bottom-color: #BBBBBB;
}
.select-group::after {
  border-width: 8px 6.5px 0 6.5px;
  border-top-color: #BBBBBB;
  top: 25%;
}
@-moz-document url-prefix() {
  .select-group {
    border-right: 1px solid #8C683C;
  }
  .select-group:hover {
    border-right: 1px solid #8C683C;
  }
}
.select-group:hover select {
  box-shadow: 0 2px 1px rgba(0, 91, 166, 0.1) inset;
  border-color: #8C683C;
}
.select-group:hover select:focus {
  outline-color: transparent;
}
.select-group:hover::before {
  border-bottom-color: #8C683C;
}
.select-group:hover::after {
  border-top-color: #8C683C;
}
.select-group label {
  padding: 0;
  height: 1.2em;
}

.select-group select {
  border: 1px solid #8C683C;
  border-radius: 0;
  font-weight: 400;
  color: #555;
  margin: -0.88em 0 0 0;
  padding: 0.5em 0 0.5em 0.5em;
  line-height: normal;
  transition: border-color 0.2s ease, outline 0.2s ease;
}
.select-group select:focus {
  box-shadow: 0 1px 4px rgba(0, 91, 166, 0.3) inset;
  outline: 1px solid #8C683C;
  outline-offset: -3px;
}
.select-group select[disabled], .select-group select:disabled {
  opacity: 0.4;
  cursor: not-allowed;
}
.select-group select:not(:focus):invalid {
  color: #727272;
}

.input-holder {
  border:1px solid #676767;
  width: 32px;
  height:20px;
  text-align: center;
  padding: 2px 3px;
}
.input-holder:nth-child(3){
  width: 60px;
  height:20px;
  text-align: center;
  /* padding-left: 3px; */
}
/*  ::first-letter works ONLY on elements with a display value of block, inline-block, table-cell, list-item or table-caption. In all other cases, ::first-letter has no effect. */
#review-club-type {
padding-top: 1px;
}
#review-club-type::first-letter {
    text-transform: capitalize;
}


.select-contain {
  margin-top: -2.75em;
  user-select: none;
}
.select-mem-contain {
  margin-top: -2.5em;
  user-select: none;
}

.membership-type-contain {
  padding-top: 2em;
  margin-top: -2.75em;
}

.step-4-group {
  margin-top: -2.05em;
}
.date-format-hint {
  font-weight: bold;
  color: #777;
  font-size: 0.98em;
  transform: translate3d(0,0.5em,0);
}

.error-handle-container {
  color: #222;
  line-height: 1.25em;
  padding: 0 0 0 0.67em;
}
.invalid-red {
  border: 2px solid #D00D00;
}
.invalid-red-text {
  color: #D00D00;
}
.no-border {
  border: none;
}

.password-show {
  position: absolute;
  top: 0.45em;
  right: 3ch;
  z-index: 9999;
  zoom:1.2;
}
.password-show i.fa-eye-slash {
  color: #555;
}
.password-show i.fa-eye {
  color: #222;
}
/*  */
@media screen and (min-width: 650px){
  max-width: 875px;
  margin: auto;
  zoom: 1.15;


  #next-button {
    min-width: 12em;
    max-width: 15em;
    background-color: #9c7456;
  }
  .btn-primary { 
    background-color: #9c7456;
  }
  .pickup-text {
  font-weight: bold;
  color: #906010;
  text-align: left;
  font-size: 1em;
  margin: -29em 0 0 -20px;
}

  .map-card {
    height: 90vh;
    width: 75vw;
    box-shadow: none;
    background: transparent;
  }

  .card-selections{
    display: flex;
    -webkit-flex-wrap: nowrap;
    -ms-flex-wrap: nowrap;
    flex-wrap: nowrap;
    overflow: scroll;
    width: 100%;
    position: relative;
    top: -34em;
    left: 54vw;
    min-height: 12em;
    max-height: 50vh;
    gap: 0.1em;
    flex-direction: column;
  }

}


`;

export default StyledFormStep